// extracted by mini-css-extract-plugin
export default {"groupTitle":"Documents_groupTitle__jm5cr","group":"Documents_group__7etIb"};